import React from 'react';
import { Edit, Trash2 } from 'lucide-react';

const UserList = ({ users, currentUser, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const canDelete = (user) => {
    return currentUser && user.id !== currentUser.id;
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Email</th>
            <th>Nom d'utilisateur</th>
            <th>Statut</th>
            <th>Créé le</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>
                {user.email}
                {currentUser && user.id === currentUser.id && (
                  <span className="badge bg-primary ms-2">Vous</span>
                )}
              </td>
              <td>{user.username}</td>
              <td>
                <span className={`badge ${user.blocked ? 'bg-danger' : 'bg-success'}`}>
                  {user.blocked ? 'Bloqué' : 'Actif'}
                </span>
              </td>
              <td>{formatDate(user.createdAt)}</td>
              <td>
                <div className="btn-group btn-group-sm">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => onEdit(user)}
                    title="Modifier"
                  >
                    <Edit size={16} />
                  </button>
                  {canDelete(user) && (
                    <button
                      className="btn btn-outline-danger"
                      onClick={() => onDelete(user.id)}
                      title="Supprimer"
                    >
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {users.length === 0 && (
        <div className="text-center py-4">
          <p className="text-muted">Aucun utilisateur trouvé</p>
        </div>
      )}
    </div>
  );
};

export default UserList;